//	Removes non-ascii, non-number characters and multiple spaces
const cleanString = str => str.replace(/[^a-zA-Z\d\s]/gi, '').replace(/\s/g, ' ').replace(/\s\s+/g, ' ').trim()

export default cleanString



// WEBPACK FOOTER //
// ./src/utilities/Data/cleanString.js